export const badRequestMessage = 'Ошибка обработки запроса, повторите позже.';

// Строки в массивах так как в разметке перенос строки и они лежат в разных Typography
export const mainNameWithYear = [
  `© ${new Date().getFullYear()} «Клиническая больница`, 
  '"РЖД-Медицина" имени Н.А. Семашко»'
];

export const mainNameWithoutYear = [
  'Клиническая больница "РЖД-Медицина"',
  'имени Н.А Семашко'
]

export const footerText = {
  highlighted: 'Личный кабинет ',
  msg1: '«Клиническая больница»',
  msg2: `«РЖД-Медицина» имени Н.А. Семашко © ${new Date().getFullYear()}`
}
